// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("./Expln_utils_common.bs.js");

function describe$1(name, test) {
  describe(name, (function () {
          return Curry._1(test, undefined);
        }));
}

function describe_skip(name, test) {
  describe.skip(name, (function () {
          return Curry._1(test, undefined);
        }));
}

function it$1(name, test) {
  it(name, (function () {
          try {
            return Curry._1(test, undefined);
          }
          catch (raw_exn){
            var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
            console.log("##############################################################");
            console.log("error in test", exn);
            console.log("##############################################################");
            throw exn;
          }
        }));
}

function it_skip(name, test) {
  it.skip(name, (function () {
          return Curry._1(test, undefined);
        }));
}

function assertEq(actual, expected) {
  if (Caml_obj.notequal(expected, actual)) {
    return Expln_utils_common.exn("\n  actual: " + Expln_utils_common.stringify(actual) + "\nexpected: " + Expln_utils_common.stringify(expected) + "");
  }
  
}

function assertEqMsg(actual, expected, msg) {
  if (Caml_obj.notequal(expected, actual)) {
    return Expln_utils_common.exn("\nAssertion failed for '" + msg + "'\n  actual: " + Expln_utils_common.stringify(actual) + "\nexpected: " + Expln_utils_common.stringify(expected) + "");
  }
  
}

function assertEqNum(actual, expected, precision) {
  if (actual <= expected - precision || actual >= expected + precision) {
    return Expln_utils_common.exn("\n  actual: " + String(actual) + "\nexpected: " + String(expected) + "");
  }
  
}

function assertEqNumMsg(actual, expected, precision, msg) {
  if (actual <= expected - precision || actual >= expected + precision) {
    return Expln_utils_common.exn("\nAssertion failed for '" + msg + "'\n  actual: " + String(actual) + "\nexpected: " + String(expected) + "");
  }
  
}

function fail(param) {
  return Expln_utils_common.exn("Test failed.");
}

function failMsg(str) {
  return Expln_utils_common.exn("Test failed: " + str);
}

var startProfile = (() => console.profile());

var stopProfile = (() => console.profileEnd());

var startTimer = (label => console.time(label));

var stopTimer = (label => console.timeEnd(label));

exports.describe = describe$1;
exports.describe_skip = describe_skip;
exports.it = it$1;
exports.it_skip = it_skip;
exports.assertEq = assertEq;
exports.assertEqMsg = assertEqMsg;
exports.assertEqNum = assertEqNum;
exports.assertEqNumMsg = assertEqNumMsg;
exports.fail = fail;
exports.failMsg = failMsg;
exports.startProfile = startProfile;
exports.stopProfile = stopProfile;
exports.startTimer = startTimer;
exports.stopTimer = stopTimer;
/* No side effect */
